import request from '../../utils/request';
import { stringify } from 'qs';

export async function saveComment(params) {
  return request('/api/tscloud-res/res-comment/submit', {
    method: 'POST',
    body: params,
  });
}

export async function getComments(params) {
  return request(`/api/tscloud-res/res-comment/page?${stringify(params)}`);
}

export async function getReplies(params) {
  return request(`/api/tscloud-res/res-comment/page?${stringify(params)}`);
}
